import { withGradualZoomOptions } from "../../utils/gradualMapZoom";

export function calculateDistance(lat1, lng1, lat2, lng2) {
  const R = 6371000;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

export function calculateBearing(lat1, lng1, lat2, lng2) {
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const lat1Rad = (lat1 * Math.PI) / 180;
  const lat2Rad = (lat2 * Math.PI) / 180;

  const x = Math.sin(dLng) * Math.cos(lat2Rad);
  const y =
    Math.cos(lat1Rad) * Math.sin(lat2Rad) -
    Math.sin(lat1Rad) * Math.cos(lat2Rad) * Math.cos(dLng);

  let bearing = (Math.atan2(x, y) * 180) / Math.PI;
  bearing = (bearing + 360) % 360;
  return bearing;
}

export function formatDistance(meters) {
  if (meters >= 1000) {
    return `${(meters / 1000).toFixed(2)} km`;
  }
  return `${meters.toFixed(2)} m`;
}

export function buildBearingData(pointA, pointB) {
  const distance = calculateDistance(
    pointA.lat,
    pointA.lng,
    pointB.lat,
    pointB.lng
  );
  const bearing = calculateBearing(
    pointA.lat,
    pointA.lng,
    pointB.lat,
    pointB.lng
  );
  return {
    pointA,
    pointB,
    distance,
    bearing,
  };
}

export function formatTrackHeadingSummary(data, serviceFarmName) {
  const farmLine = serviceFarmName ? `Fazenda: ${serviceFarmName}` : "";
  return [
    "Rumo de Pista A-B — AgriConnected",
    farmLine,
    `Ponto A: ${data.pointA.lat.toFixed(6)}, ${data.pointA.lng.toFixed(6)}`,
    `Ponto B: ${data.pointB.lat.toFixed(6)}, ${data.pointB.lng.toFixed(6)}`,
    `Rumo A→B: ${data.bearing.toFixed(2)}°`,
    `Distância: ${formatDistance(data.distance)}`,
  ]
    .filter(Boolean)
    .join("\n");
}

export function getMapOptions(maps) {
  return withGradualZoomOptions({
    streetViewControl: true,
    scaleControl: true,
    fullscreenControl: true,
    gestureHandling: "greedy",
    disableDoubleClickZoom: false,
    minZoom: 2,
    maxZoom: 22,
    mapTypeId: maps.MapTypeId.SATELLITE,
    clickableIcons: false,
  });
}
